import type { ComponentType } from "react"

// Every Inertia page under every domain's pages/ directory, eagerly loaded
// so resolution is synchronous. One glob reaches every domain forever —
// naming none of them (FR-2.7, AC-17) — and the negative pattern keeps
// co-located page tests out of the page map.
const pages = import.meta.glob<{ default: ComponentType }>(
  ["../domains/*/pages/*.tsx", "!../domains/*/pages/*.test.tsx"],
  { eager: true },
)

/**
 * Resolves a domain-qualified Inertia page identifier (e.g. "schedule/Days")
 * to its page component. The identifier carries its domain so two domains
 * may hold same-named pages without collision (FR-3.3).
 */
export function resolvePage(name: string): ComponentType {
  const path = `../domains/${name.replace("/", "/pages/")}.tsx`
  const page = pages[path]

  if (!page) {
    throw new Error(`Unknown Inertia page "${name}" (expected a module at ${path})`)
  }

  return page.default
}
